import PropTypes from 'prop-types';
import {Container, Image, GiftPrice, Units} from './styles';
import placeholderWhite from 'assets/img/placeholderWhite.png';

const HomepageGift = ({acf}) => {
  if (!acf) return null;
  const {cadeaux_points: points, cadeaux_image: imageUrl} = acf;

  return (
    <Container>
      <Image src={imageUrl} placeholder={placeholderWhite} />
      <GiftPrice>
        {points}
        <Units>pts</Units>
      </GiftPrice>
    </Container>
  );
};

HomepageGift.propTypes = {
  acf: PropTypes.object,
};

export default HomepageGift;
